import { z } from 'zod';

const tokenUsageSchema = z.object({
  tokens_used: z.number().int().nonnegative(),
  tokens_limit: z.number().int().nonnegative(),
  limited: z.boolean(),
  reset_at: z.string().nullish(),
  as_of: z.string(),
});

export type TokenUsage = z.infer<typeof tokenUsageSchema>;

export const tokenAllowance = {
  getUsage: {
    path: 'token-allowance/v1/usage',
    schema: tokenUsageSchema,
  },
} as const;
